import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard/DashboardLayout';
//
import CallCenterList from './pages/CallCenter/CallCenterList';
import UpdateCallCenter from './pages/CallCenter/UpdateCallCenter';
import DashboardApp from './pages/DashboardApp';
import Integration from './pages/Integration/Integration';
import AddEditLeads from './pages/Leads/AddeditLeads';
import Leads from './pages/Leads/Leads';
import SubmitLeads from './pages/Leads/SubmitLeads';
import UpdateLeads from './pages/Leads/UpdateLeads';
import Login from './pages/Login';
import UpdateLogIn from './pages/LogIn/UpdateLogIn';
import AddEditMaster from './pages/Master/AddEditMaster';
import MasterList from './pages/Master/MasterList';
import AddEditChildMaster from './pages/MasterChild/AddEditChildMaster';
import AddEditOnBoarding from './pages/OnBoarding/AddeditOnBoarding';
import OnBoarding from './pages/OnBoarding/OnBoarding';
import NotFound from './pages/Page404';
import AddEditProspect from './pages/Prospect/AddEditProspect';
import UploadLeadProspect from './pages/Prospect/UploadLeadProspect';
import ViewProspect from './pages/Prospect/ViewProspect';
import ReapplyRejected from './pages/Rejected/ReapplyRejected';
import RejectedList from './pages/Rejected/RejectedList';
import RevenueList from './pages/Revenue/RevenueList';
import UpdateRevenue from './pages/Revenue/UpdateRevenue';
import AddEditUser from './pages/Users/AddEditUser';
import Users from './pages/Users/Users';
// import Invoice from './pages/Invoice/Invoice';
// import UpdateInvoice from './pages/Invoice/UpdateInvoice';
import CustomerList from './pages/Customer/CustomerList';
import DecisionLogIn from './pages/LogIn/DecisionLogIn';
import LogIn from './pages/LogIn/LogIn';
import AddEditPartners from './pages/Partners/AddEditPartners';
import PartnersList from './pages/Partners/PartnersList';
import ViewPartner from './pages/Partners/ViewPartner';
// import RaiseInvoice from './pages/Invoice/RaiseInvoice';
// import PaymentInvoice from './pages/Invoice/PaymentInvoice';
import ViewLogin from './pages/LogIn/ViewLogin';
// import ViewRevenue from './pages/Revenue/ViewRevenue';
import AddAgreement from './pages/Agreement/AddAgreement';
// import AddPolicy from './pages/Agreement/AddPolicy';
import Agreement from './pages/Agreement/Agreement';
import ViewAgreement from './pages/Agreement/ViewAgreement';
// import ViewPolicy from './pages/Agreement/ViewPolicy';
import ViewCallCenter from './pages/CallCenter/ViewCallCenter';
import AddJourney from './pages/Journey/AddJourney';
import Journey from './pages/Journey/Journey';
import JourneyConfigure from './pages/Journey/JourneyConfigure';
import JourneyConfigureLanding from './pages/Journey/JourneyConfigureLanding';
import JourneyPublish from './pages/Journey/JourneyPublish';
import JourneyTemplate from './pages/Journey/JourneyTemplate';
import ViewJourney from './pages/Journey/ViewJourney';
import ViewJourneyTemplate from './pages/Journey/ViewJourneyTemplate';
import ViewApplicationSummary from './pages/Leads/ViewApplicationSummary';
import SubmitLogin from './pages/LogIn/SubmitLogin';
import BusinessReviewOnBoarding from './pages/OnBoarding/BusinessReviewOnBoarding';
import EditOnBoarding from './pages/OnBoarding/EditOnBoarding';
import ReviewOnBoarding from './pages/OnBoarding/ReviewOnBoarding';
import SetCommissionOnBoarding from './pages/OnBoarding/SetCommissionOnBoarding';
import InvoiceGeneratePayable from './pages/Payable/InvoiceGeneratePayable';
import Payable from './pages/Payable/Payable';
import ViewPayable from './pages/Payable/ViewPayable';
import Report from './pages/Report/Report';
import ViewReport from './pages/Report/ViewReport';
import AddEditPayout from './pages/Payout/AddEditPayout';
import InvoiceGeneratePayout from './pages/Payout/InvoiceGeneratePayout';
import PayoutList from './pages/Payout/PayoutList';
import UploadBulkFilePayout from './pages/Payout/UploadBulkFilePayout';
import ViewPayout from './pages/Payout/ViewPayout';
import PrivacyPolicyText from './pages/PrivacyPolicyText';
import ProspectListView from './pages/Prospect/ProspectListView';
import InvoiceGenerate from './pages/Receivable/InvoiceGenerate';
import PaymentInvoice from './pages/Receivable/PaymentInvoice';
import Receivable from './pages/Receivable/Receivable';
import UpdateInvoice from './pages/Receivable/UpdateInvoice';
import ViewFile from './pages/Receivable/ViewFile';
import ViewMultipleFile from './pages/Receivable/ViewMultipleFile';
import NewRecommendation from './pages/Recommendation/NewRecommendation';
import ViewRejected from './pages/Rejected/ViewRejected';
import AddEditRevenue from './pages/Revenue/AddEditRevenue';
import InvoiceGenerateRevenue from './pages/Revenue/InvoiceGenerateRevenue';
import UploadBulkFile from './pages/Revenue/UploadBulkFile';
import ViewRevenue from './pages/Revenue/ViewRevenue';
import SignUp from './pages/SignUp';
import SignUpCompany from './pages/SignUpCompany';
import SignUpIndividual from './pages/SignUpIndividual';
import SignUpSec from './pages/SignUpSec';
import TermConditionsText from './pages/TermConditionsText';
import SalesList from './pages/Sales/SalesList';

// import ViewRecommendationSingleB from './pages/Recommendation/ViewRecommendationSingleB';
import ActivityLeads from './pages/Leads/ActivityLeads';
import AppointmentList from './pages/Leads/AppointmentList';
import CommentsLeads from './pages/Leads/CommentsLeads';
import PrintDownloadApplicationLeads from './pages/Leads/PrintDownloadApplicationLeads';
import ProcessLeads from './pages/Leads/ProcessLeads';
import ProcessLogin from './pages/LogIn/ProcessLogin';
import Recommendation from './pages/Recommendation/Recommendation';
import ViewRecommendation from './pages/Recommendation/ViewRecommendation';
// import InvoiceGenerate from './pages/Invoice/InvoiceGenerate';

import Bankops from './pages/Bankops/Bankops';
import DecisionBankops from './pages/Bankops/DecisionBankops';
import UpdateBankops from './pages/Bankops/UpdateBankops';
import ViewBankops from './pages/Bankops/ViewBankops';

import Disburse from './pages/Disburse/Disburse';
import ProcessDisburse from './pages/Disburse/ProcessDisburse';
import UpdateDisburse from './pages/Disburse/UpdateDisburse';
import ViewDisburse from './pages/Disburse/ViewDisburse';
import AddPolicy from './pages/Policy/AddPolicy';
import PolicyList from './pages/Policy/PolicyList';
import UploadPolicy from './pages/Policy/UploadPolicy';
import ViewPolicy from './pages/Policy/ViewPolicy';
import DashboardApplication from './layouts/dashboard/DashboardApplication';
import RecommendationConfigure from './pages/Global/RecommendationConfigure';
import RecommendationApplication from './pages/Global/RecommendationApplication';
import LeadConfigure from './pages/Global/LeadConfigure';
import LeadApplication from './pages/Global/LeadApplication';
import SignUpNew from './pages/SignUpNew';
import axiosInstance from './utils/https';
import { store } from './store';
import RecoEnginePage from './pages/Global/RecoEnginePage';
import UpdatePassword from './pages/UpdatePassword';
import ViewUser from './pages/Users/ViewUser';
import DataList from './pages/Data/DataList';
import ViewDataSet from './pages/Data/ViewDataSet';
import DataValidate from './pages/Data/DataValidate';
import DataAdd from './pages/Data/DataAdd';
import CheckBureau from './pages/Data/CheckBureau';
// import Allocation from '../pages/Data/Allocation';
import Allocation from './pages/Data/Allocation';
import CustomerView from './pages/Customer/CustomerView';
import AddLoginFile from './pages/Bankops/AddLoginFile';
import SetIncentiveForEmployeePartner from './pages/Users/SetIncentiveForEmployeePartner';
import EditIncentive from './pages/Users/EditIncentive';
import Accounting from './pages/Accounting/Accounting';

// ----------------------------------------------------------------------

export default function Router() {
  // Add request interceptor (optional)
  // const data = store.getState() || {};
  // const token = data?.Login?.login_data?.jwt;

  // axiosInstance.interceptors.request.use(
  //   (config) => {
  //     if (token) {
  //       config.headers.Authorization = `Bearer ${token}`;
  //     }
  //     return config;
  //   },
  //   (error) => Promise.reject(error)
  // );

  // Add response interceptor (optional)
  // axiosInstance.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     // Handle errors globally
  //     if (error.response && error.response.status === 401) {
  //       // Example: redirect to login
  //       console.log('Unauthorized! Redirect to login.');
  //     }
  //     return Promise.reject(error);
  //   }
  // );

  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        {
          path: '',
          element: <DashboardApp />,
          children: [{ path: '', element: <DashboardApp /> }]
        }
      ]
    },
    {
      path: '/accounting',
      element: <DashboardLayout />,
      children: [
        {
          path: '',
          children: [{ path: '', element: <Accounting /> }]
        }
      ]
    },
    {
      path: '/prospect',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <ProspectListView /> },
        { path: 'add', element: <AddEditProspect /> },
        { path: 'edit/:rowId', element: <AddEditProspect /> },
        { path: 'view', element: <ViewProspect /> },
        { path: 'upload', element: <UploadLeadProspect /> }
      ]
    },
    {
      path: '/onboarding',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <OnBoarding /> },
        { path: 'add', element: <AddEditOnBoarding /> },
        { path: 'review', element: <ReviewOnBoarding /> },
        { path: 'business-review', element: <BusinessReviewOnBoarding /> },
        { path: 'set-commission', element: <SetCommissionOnBoarding /> },
        { path: 'edit/:rowId', element: <EditOnBoarding /> }
      ]
    },
    // {
    //   path: '/invoice',
    //   element: <DashboardLayout />,
    //   children: [
    //     { path: '', element: <Invoice /> },
    //     { path: 'raise-invoice', element: <RaiseInvoice /> },
    //     { path: 'invoice-generate', element: <InvoiceGenerate /> },
    //     { path: 'payment-invoice', element: <PaymentInvoice /> },
    //     { path: 'update', element: <UpdateInvoice /> }
    //   ]
    // },
    {
      path: '/call-center',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <CallCenterList /> },
        { path: 'update', element: <UpdateCallCenter /> },
        { path: 'add', element: <AddEditChildMaster /> },
        { path: 'view', element: <ViewCallCenter /> },
        { path: 'edit/:rowId', element: <AddEditChildMaster /> }
      ]
    },
    {
      path: '/receivable',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Receivable /> },
        { path: 'view-file', element: <ViewFile /> },
        { path: 'view-multiple-invoice', element: <ViewMultipleFile /> },
        { path: 'payment-invoice', element: <PaymentInvoice /> },
        { path: 'invoice-generate', element: <InvoiceGenerate /> },
        { path: 'update', element: <UpdateInvoice /> }
      ]
    },
    {
      path: '/revenue',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <RevenueList /> },
        { path: 'update', element: <UpdateRevenue /> },
        // { path: 'add-approved', element: <AddEditRevenueApproved /> },
        // { path: 'add-disbursed', element: <AddEditRevenueDisbursed /> },
        { path: 'add-receipt', element: <AddEditRevenue /> },
        { path: 'add-approved', element: <AddEditRevenue /> },
        { path: 'add-disbursed', element: <AddEditRevenue /> },
        // { path: 'upload-receipt', element: <UploadBulkFileReceipt /> },
        // { path: 'upload-approved', element: <UploadBulkFileApproved /> },
        // { path: 'upload-disbursed', element: <UploadBulkFileDisbursed /> },
        { path: 'upload-receipt', element: <UploadBulkFile /> },
        { path: 'upload-approved', element: <UploadBulkFile /> },
        { path: 'upload-disbursed', element: <UploadBulkFile /> },
        { path: 'view-receipt', element: <ViewRevenue /> },
        { path: 'view-approved', element: <ViewRevenue /> },
        { path: 'view-disbursed', element: <ViewRevenue /> },
        // { path: 'view-approved', element: <ViewRevenueApproved /> },
        // { path: 'view-disbursed', element: <ViewRevenueDisbursed /> },
        { path: 'invoice', element: <InvoiceGenerateRevenue /> },
        { path: 'edit/:rowId', element: <AddEditRevenue /> }
      ]
    },
    {
      path: '/payout',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <PayoutList /> },
        { path: 'add', element: <AddEditPayout /> },
        { path: 'upload', element: <UploadBulkFilePayout /> },
        { path: 'view', element: <ViewPayout /> },
        { path: 'invoice', element: <InvoiceGeneratePayout /> },
        { path: 'edit/:rowId', element: <AddEditPayout /> }
      ]
    },
    {
      path: '/sales',
      element: <DashboardLayout />,
      children: [{ path: '', element: <SalesList /> }]
    },
    {
      path: '/branch',
      element: <DashboardLayout />
      // children: [{ path: '', element: <BranchList /> }]
    },
    {
      path: '/data',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <DataList /> },
        { path: 'view', element: <ViewDataSet /> },
        { path: 'validate', element: <DataValidate /> },
        { path: 'add', element: <DataAdd /> },
        { path: 'check-bureau', element: <CheckBureau /> },
        { path: 'allocation', element: <Allocation /> }
      ]
    },
    {
      path: '/payable',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Payable /> },
        { path: 'view', element: <ViewPayable /> },
        { path: 'invoice', element: <InvoiceGeneratePayable /> }
      ]
    },
    {
      path: '/report',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Report /> },
        { path: 'view', element: <ViewReport /> }
      ]
    },
    // {
    //   path: '/revenue',
    //   element: <DashboardLayout />,
    //   children: [
    //     { path: '', element: <RevenueList /> },
    //     { path: 'add', element: <AddEditUser /> },
    //     { path: 'update', element: <UpdateRevenue /> },
    //     { path: 'view', element: <ViewRevenue /> },
    //     { path: 'edit/:rowId', element: <AddEditUser /> }
    //   ]
    // },
    {
      path: '/leads',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Leads /> },
        { path: 'add', element: <AddEditLeads /> },
        { path: 'submit', element: <SubmitLeads /> },
        { path: 'update', element: <UpdateLeads /> },
        // { path: 'view', element: <ViewLeads /> },
        { path: 'application-summary', element: <ViewApplicationSummary /> },
        { path: 'edit/:rowId', element: <AddEditLeads /> },
        { path: 'appointment', element: <AppointmentList /> },
        // { path: 'reco-engine-section', element: <RecoEnginePage /> },
        {
          path: 'activity',
          children: [
            { path: '', element: <ActivityLeads /> },
            { path: 'update', element: <UpdateLeads /> },
            { path: 'comments', element: <CommentsLeads /> }
          ]
        },

        {
          path: 'process',
          children: [
            { path: '', element: <ProcessLeads /> },
            { path: 'print-download', element: <PrintDownloadApplicationLeads /> }
          ]
        }
      ]
    },
    { path: '/leads/reco-engine-section', element: <RecoEnginePage /> },
    {
      path: '/recommendation',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Recommendation /> },
        { path: 'new-recommendation', element: <NewRecommendation /> },
        { path: 'view-recommendation', element: <ViewRecommendation /> }
      ]
    },
    {
      path: '/recommendation',
      element: <DashboardApplication />,
      children: [
        { path: 'recommendation-configure', element: <RecommendationConfigure /> },
        { path: 'recommendation-application', element: <RecommendationApplication /> }
      ]
    },
    {
      path: '/leads',
      element: <DashboardApplication />,
      children: [
        { path: 'lead-configure', element: <LeadConfigure /> },
        { path: 'lead-application', element: <LeadApplication /> }
      ]
    },
    {
      path: '/journey',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Journey /> },
        { path: 'add', element: <AddJourney /> },
        { path: 'configure', element: <JourneyConfigure /> },
        { path: 'template', element: <JourneyTemplate /> },
        { path: 'landing-page', element: <JourneyConfigureLanding /> },
        { path: 'view', element: <ViewJourney /> },
        { path: 'publish', element: <JourneyPublish /> },
        { path: 'viewTemplate', element: <ViewJourneyTemplate /> }
      ]
    },
    {
      path: '/rejected',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <RejectedList /> },
        { path: 'reapply', element: <ReapplyRejected /> },
        { path: 'view', element: <ViewRejected /> }
      ]
    },
    {
      path: '/login',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <LogIn /> },
        { path: 'decision', element: <DecisionLogIn /> },
        { path: 'view', element: <ViewLogin /> },
        { path: 'update', element: <UpdateLogIn /> },
        { path: 'submit', element: <SubmitLogin /> },
        {
          path: 'process',
          children: [{ path: '', element: <ProcessLogin /> }]
        }
      ]
    },
    {
      path: '/bankops',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Bankops /> },
        { path: 'decision', element: <DecisionBankops /> },
        { path: 'view', element: <ViewBankops /> },
        { path: 'update', element: <UpdateBankops /> },
        { path: 'add-login-file', element: <AddLoginFile /> }
      ]
    },
    {
      path: '/disburse',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Disburse /> },
        { path: 'decision', element: <DecisionLogIn /> },
        { path: 'view', element: <ViewDisburse /> },
        { path: 'process', element: <ProcessDisburse /> },
        { path: 'update', element: <UpdateDisburse /> }
      ]
    },
    {
      path: '/integration',
      element: <DashboardLayout />,
      children: [{ path: '', element: <Integration /> }]
    },
    {
      path: '/master',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <MasterList /> },
        { path: 'add', element: <AddEditMaster /> },
        { path: 'edit/:rowId', element: <AddEditMaster /> }
      ]
    },
    {
      path: '/users',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Users /> },
        { path: 'add', element: <AddEditUser /> },
        { path: 'edit/:rowId', element: <AddEditUser /> },
        { path: 'view/:rowId', element: <ViewUser /> },
        { path: 'set-Incentive-For-EmployeePartner', element: <SetIncentiveForEmployeePartner /> },
        { path: 'edit-incentive', element: <EditIncentive /> }
      ]
    },
    {
      path: '/partners',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <PartnersList /> },
        { path: 'add', element: <AddEditPartners /> },
        { path: 'edit/:rowId', element: <EditOnBoarding /> },
        { path: 'view/:rowId', element: <ViewPartner /> }
      ]
    },
    {
      path: '/customer',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <CustomerList /> },
        { path: 'view', element: <CustomerView /> }
      ]
    },
    {
      path: '/agreement',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Agreement /> },
        { path: 'add', element: <AddAgreement /> },
        { path: 'view', element: <ViewAgreement /> },
        { path: 'edit', element: <AddAgreement /> }
      ]
    },
    {
      path: '/policy',
      element: <DashboardLayout />,
      children: [
        { path: '', element: <PolicyList /> },
        { path: 'add-policy', element: <AddPolicy /> },
        { path: 'view-policy', element: <ViewPolicy /> },
        { path: 'edit-policy', element: <AddPolicy /> },
        { path: 'upload-policy', element: <UploadPolicy /> }
      ]
    },
    {
      path: '/',
      element: <Login />,
      children: [
        { path: 'login', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    {
      path: '/signup',
      element: <SignUp />
    },
    {
      path: '/signup-new',
      element: <SignUpNew />
    },
    {
      path: '/signup-form',
      element: <SignUpSec />
    },
    {
      path: '/signup-form/company',
      element: <SignUpCompany />
    },
    {
      path: '/signup-form/individual',
      element: <SignUpIndividual />
    },
    {
      path: '/update-password',
      element: <UpdatePassword />
    },
    {
      path: '/privacy-policy',
      element: <PrivacyPolicyText />
    },
    {
      path: '/term-conditions',
      element: <TermConditionsText />
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
